import React from "react";
import {
  CtaWidgetContainer,
  Title,
  Description,
  CtaButton,
  ImageContainer,
  ContentContainer
} from "./CtaWidget.styled";

const CtaWidget = ({
  title,
  description,
  ctaButtonLabel,
  image,
  onCtaButtonClick,
  // styles
  containerBackgroundColor = "",
  containerBorderColor = "",
  imageBackgroundColor = "",
  titleTextColor = "",
  descriptionTextColor = "",
  ctaButtonTextColor = "",
  ctaButtonBackgroundColor = ""
}) => {
  return (
    <CtaWidgetContainer
      containerBackgroundColor={containerBackgroundColor}
      containerBorderColor={containerBorderColor}
    >
      <ImageContainer imageBackgroundColor={imageBackgroundColor} image={image} />
      <ContentContainer>
        <Title titleTextColor={titleTextColor}>{title}</Title>
        <Description descriptionTextColor={descriptionTextColor}>{description}</Description>
        <CtaButton
          ctaButtonTextColor={ctaButtonTextColor}
          ctaButtonBackgroundColor={ctaButtonBackgroundColor}
          onClick={onCtaButtonClick}
        >
          {ctaButtonLabel}
        </CtaButton>
      </ContentContainer>
    </CtaWidgetContainer>
  );
};

export default CtaWidget;
